export default __webpack_public_path__ + "static/media/ya.258eca17.svg";